export default "__VITE_ASSET__CFg9P16k__"